<div class="head">
  <img class="bg" src="/assets/lerobert/img/landing/tetiere@2x.png" />

  <div fxHide.xs class="img-2">
    <img height="400" src="/assets/lerobert/img/landing/le-robert-pro@2x.png" />
  </div>
</div>

<section class="section-1 mat-padding-2">
  <div class="container">
    <div class="text-center mat-display-1 title-1 read">
      <b class="blue">Une formation pédagogique complète,</b><br />personnalisée
      et accompagnée par l’expert de la langue française, Le Robert.
    </div>

    <div class="card read mat-padding mat-elevation-z1">
      <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="32px">
        <div>
          <img height="80" src="/assets/lerobert/img/landing/cpf@2x.png" />
        </div>

        <div class="mat-h2">
          100 % finançable grâce à votre<br />
          compte personnel de formation (CPF)
        </div>
      </div>

      <br />

      <div
        fxLayout="row"
        fxLayout.xs="column"
        fxLayoutGap.xs="16px"
        fxLayoutAlign="center center"
        fxLayoutGap="64px"
      >
        <a
          *ngFor="let b of buttons"
          mat-raised-button
          target="_blank"
          [innerHTML]="b.text"
          [href]="b.link"
          class="lerobert"
          color="primary"
        ></a>
      </div>
    </div>
  </div>
</section>

<div class="section-2 blue-bg mat-padding-2">
  <div class="container">
    <div
      ngClass.xs="mat-display-1"
      class="text-center mat-display-2 bold read white"
    >
      Notre offre de formation, unique en son genre, inclut trois outils
      complémentaires uniques pour vous faire progresser efficacement :
    </div>

    <div fxLayout="column" fxLayoutGap="32px">
      <div>
        <div *ngFor="let content of section2.contents; last as last">
          <div class="card mat-padding-2">
            <div
              fxLayout="row"
              fxLayout.xs="column"
              fxLayout.sm="column"
              fxLayoutGap="16px"
              fxLayoutAlign="center center"
            >
              <div fxFlex ngClass.gt-sm="text-right" ngClass.xs="text-center">
                <img
                  height="110"
                  [src]="
                    '/assets/lerobert/img/landing/' +
                    content.header.logo +
                    '@2x.png'
                  "
                />
              </div>
              <div fxHide.xs class="blue chevron-right">
                <mat-icon>chevron_right</mat-icon>
              </div>
              <div
                fxFlex
                ngClass.xs="text-center"
                ngClass.sm="text-center"
                class="mat-h1 blue bold"
                [innerHTML]="content.header.title"
              ></div>
            </div>

            <div *ngFor="let b of content.body; last as lastBody">
              <div
                fxLayout="row"
                fxLayout.xs="column"
                fxLayout.sm="column"
                fxLayoutGap="32px"
              >
                <div fxFlex>
                  <div class="mat-h2 bold blue" [innerHTML]="b.title"></div>
                  <div
                    class="mat-body-1"
                    fxLayout="row"
                    fxLayoutGap="4px"
                    fxLayout="center"
                  >
                    <mat-icon class="blue">schedule</mat-icon>
                    <div class="subTitle mat-body-2">
                      {{ b.subTitle }}
                    </div>
                  </div>

                  <ul fxLayout="column" fxLayoutGap="16px">
                    <li
                      *ngFor="let i of b.items"
                      class="item"
                      [innerHTML]="i | safe: 'html'"
                    ></li>
                  </ul>
                </div>

                <div fxFlex>
                  <img
                    class="img-responsive"
                    [src]="'/assets/lerobert/img/landing/' + b.img + '@2x.png'"
                  />
                </div>
              </div>

              <div *ngIf="!lastBody" class="circle">
                &
              </div>
            </div>
          </div>

          <div *ngIf="!last" class="sep">
            <mat-icon>add</mat-icon>
          </div>
        </div>
      </div>

      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        fxLayoutGap="64px"
        fxLayout.xs="column"
        fxLayoutGap.xs="16px"
      >
        <a
          *ngFor="let b of buttons"
          mat-raised-button
          class="lerobert"
          color="primary"
          mat-raised-button
          target="_blank"
          [innerHTML]="b.text"
        ></a>
      </div>
    </div>
  </div>
</div>

<div>
  <img
    style="object-fit: contain; width: 100%;"
    src="/assets/lerobert/img/landing/work@2x.png"
    alt=""
  />
</div>

<div class="section-3 mat-padding-2 white-bg">
  <div class="container mat-padding-2">
    <div class="mat-display-1 text-center read blue bold">
      Des résultats éprouvés en 14 heures<br />de formation seulement !
    </div>

    <div style="width: 700px" class="read">
      <div fxLayout="column" fxLayoutGap="48px">
        <div
          *ngFor="let i of section3.items; index as index"
          fxLayout="row"
          fxLayoutGap="16px"
        >
          <div class="step white text-center">
            <div class="time">
              Temps
            </div>
            <div class="number">
              {{ index + 1 }}
            </div>
          </div>

          <div fxFlex>
            <div class="content">
              <div class="mat-h2 bold blue" style="margin-bottom: 4px;">
                {{ i.title }}
              </div>
              <div
                style="margin-bottom: 4px;"
                class="mat-body-1"
                fxLayout="row"
                fxLayoutGap="4px"
                fxLayout="center"
              >
                <mat-icon class="blue">schedule</mat-icon>
                <div class="subTitle mat-body-2">
                  {{ i.subTitle }}
                </div>
              </div>

              <div class="mat-body-2">
                {{ i.description }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <br />
      <br />
      <br />

      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        fxLayoutGap="64px"
        fxLayout.xs="column"
        fxLayoutGap.xs="16px"
      >
        <a
          *ngFor="let b of buttons"
          mat-raised-button
          class="lerobert"
          color="primary"
          mat-raised-button
          target="_blank"
          [innerHTML]="b.text"
        ></a>
      </div>
    </div>
  </div>
</div>

<polylearn-lerobert-footer></polylearn-lerobert-footer>
